// import { click } from '@testing-library/user-event/dist/click';
import CELL_DATA_TYPES from '../cell-types.config';
import { ACTIONS } from '../const.config';

// App sessions module configurations
export const LISTING_COLUMNS = [
  {
    id: 'appName',
    label: 'App Name',
    width: '10%',
    align: 'left',
    dataKey: 'appName',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'platform',
    label: 'Platform',
    width: '7%',
    align: 'left',
    dataKey: 'platform',
    sortable: true,
    type: CELL_DATA_TYPES.PLATFORM,
  },
  {
    id: 'isLive',
    label: 'Live',
    width: '5%',
    align: 'center',
    dataKey: 'isLive',
    sortable: true,
    type: CELL_DATA_TYPES.BOOL,
  },
  {
    id: 'brdUserCurrentValue',
    label: 'BRD Current Status',
    width: '5%',
    align: 'center',
    dataKey: 'brdUserCurrentValue',
    sortable: true,
    type: CELL_DATA_TYPES.BOOL,
  },
  {
    id: 'deviceId',
    label: 'Device Id',
    width: '15%',
    align: 'left',
    dataKey: 'deviceId',
    sortable: false,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'gameVideoSessions',
    label: 'Game / Video Sessions',
    width: '5%',
    align: 'center',
    dataKey: 'gameVideoSessions',
    clickable: true,
    sortable: true,
    type: CELL_DATA_TYPES.NUMBER,
  },
  {
    id: 'relatedAppItemClicked',
    label: 'Related Apps Item Clicked',
    width: '5%',
    align: 'center',
    clickable: true,
    dataKey: 'relatedAppItemClicked',
    sortable: true,
    type: CELL_DATA_TYPES.NUMBER,
  },
  {
    id: 'countryName',
    label: 'Country / Region',
    width: '20%',
    align: 'left',
    dataKey: 'countryName',
    sortable: false,
    type: CELL_DATA_TYPES.TEXT,
    secondaryFields: [
      {
        dataKey: 'regionName',
        type: CELL_DATA_TYPES.TEXT,
      },
    ],
  },
  {
    id: 'sessionStartedAt',
    label: 'Session Start Time',
    width: '15%',
    align: 'left',
    dataKey: 'sessionStartedAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];

export const LISTING_ACTIONS = [
  {
    action: ACTIONS.VIEW.value,
    label: ACTIONS.VIEW.label,
  },
];

export const VIEW_COLUMNS = [
  {
    id: 'appName',
    label: 'App Name',
    dataKey: 'appName',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'platform',
    label: 'Platform',
    dataKey: 'platform',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'brdValue',
    label: 'BRD Value at App Start',
    dataKey: 'brdValue',
    type: CELL_DATA_TYPES.BOOL,
  },
  {
    id: 'brdUserCurrentValue',
    label: 'BRD Current State',
    dataKey: 'brdUserCurrentValue',
    type: CELL_DATA_TYPES.BOOL,
  },
  {
    id: 'brdSessionLastValue',
    label: 'BRD Value at Session End',
    dataKey: 'brdSessionLastValue',
    type: CELL_DATA_TYPES.BOOL,
  },
  {
    id: 'deviceId',
    label: 'Device Id',
    dataKey: 'deviceId',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'deviceModel',
    label: 'Device Model',
    dataKey: 'deviceModel',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'deviceManufacturer',
    label: 'Device Manufacturer',
    dataKey: 'deviceManufacturer',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'deviceBrand',
    label: 'Device Brand',
    dataKey: 'deviceBrand',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'deviceSDKVersion',
    label: 'Device SDK Version',
    dataKey: 'deviceSDKVersion',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'ip',
    label: 'IP Address',
    dataKey: 'ip',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'gameSessions',
    label: 'Game Sessions',
    dataKey: 'gameSessions',
    type: CELL_DATA_TYPES.NUMBER,
  },
  {
    id: 'relatedAppItemClicked',
    label: 'Related Apps Item Clicked',
    dataKey: 'relatedAppItemClicked',
    type: CELL_DATA_TYPES.NUMBER,
  },
  {
    id: 'countryName',
    label: 'Country / Region',
    dataKey: 'countryName',
    type: CELL_DATA_TYPES.TEXT,
    secondaryFields: [
      {
        dataKey: 'regionName',
        type: CELL_DATA_TYPES.TEXT,
      },
    ],
  },
  {
    id: 'sessionStartedAt',
    label: 'Session Start Time',
    dataKey: 'sessionStartedAt',
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
  {
    id: 'sessionEndedAt',
    label: 'Session End Time',
    dataKey: 'sessionEndedAt',
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];
